__turbopack_context__.v({
  "blok-big-title": "SortButton-module__1Ebeka__blok-big-title",
  "blok-subtitle": "SortButton-module__1Ebeka__blok-subtitle",
  "blok-title": "SortButton-module__1Ebeka__blok-title",
  "cross-icon": "SortButton-module__1Ebeka__cross-icon",
  "dropdown": "SortButton-module__1Ebeka__dropdown",
  "fullsize__button": "SortButton-module__1Ebeka__fullsize__button",
  "slideDownAndFade": "SortButton-module__1Ebeka__slideDownAndFade",
  "sort-icon": "SortButton-module__1Ebeka__sort-icon",
  "trigger-button": "SortButton-module__1Ebeka__trigger-button",
});
